import { ITransaction, IUserTransactions } from "@api/types/userTransactions";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getReducersLayout from "../utils/getReducersLayout";

const initialState: IUserTransactions = {
  deposits: [],
  withdraws: [],
};

const userTransactionsSlice = createSlice({
  initialState,
  name: "userTransactions",
  reducers: {
    ...getReducersLayout<IUserTransactions>(initialState),
    addDeposit: (
      state,
      {
        payload,
      }: PayloadAction<{
        transaction: ITransaction;
      }>
    ) => {
      state.deposits.push(payload.transaction);
    },

    addWidthdrawal: (
      state,
      {
        payload,
      }: PayloadAction<{
        transaction: ITransaction;
      }>
    ) => {
      state.withdraws.push(payload.transaction);
    },
  },
});

export const { setData, resetData, addDeposit, addWidthdrawal } =
  userTransactionsSlice.actions;

export default userTransactionsSlice;
